import React from 'react'
import styled from 'styled-components'

// Design System imports
import {
  colors,
  spacing,
  heading,
  typographyMixin,
  mediaQuery,
  borderRadius,
  borderWidth,
} from 'src/constants/marketing-ds'
import { ArrowDown } from 'src/components/icons/Arrows'
import { Play } from 'src/components/icons/Play'

const iconMap = {
  arrowDown: <ArrowDown />,
  play: <Play />,
}

const CTAButton = ({
  link,
  isDisabled,
  children,
  isOutlined,
  isOutlinedDark,
  icon = null,
  onClick,
  ...props
}) => {
  return (
    <StyledCTAButton
      $isDisabled={isDisabled}
      $isOutlined={isOutlined}
      $isOutlinedDark={isOutlinedDark}
      icon={icon}
      {...props}
      href={isDisabled ? '#' : link}
      onClick={onClick}
      className={`CTAButton ${props.className ?? ''}`}
    >
      <span className="btn-content">
        {children}
        {icon && <span className="btn-icon">{iconMap[icon]}</span>}
      </span>
    </StyledCTAButton>
  )
}

export default CTAButton

const StyledCTAButton = styled.a`
  position: relative;
  display: inline-block;
  color: ${colors.semantic.text.primary};
  text-align: center;
  text-decoration: none;
  box-sizing: border-box;
  white-space: nowrap;
  max-width: 100%;

  ${typographyMixin(heading.sm)}
  background: ${colors.orange[90]};
  border-radius: ${borderRadius.xs};
  padding: ${spacing.sm} ${spacing.md};

  ${mediaQuery.mobileMin} {
    padding: ${spacing.sm} ${spacing.xxl};
  }

  ${mediaQuery.tablet} {
    ${typographyMixin(heading.md)}
    padding: ${spacing.md} ${spacing.xxl};
    border-radius: ${borderRadius.sm};
  }

  ${({ $isOutlined }) =>
    $isOutlined &&
    `
      background: transparent;
      border: ${borderWidth.sm} solid ${colors.white};
      color: ${colors.white};
      border-radius: ${borderRadius.xs};
      padding: calc(${spacing.sm} - ${borderWidth.sm}) calc(${spacing.md} - ${borderWidth.sm});
      ${mediaQuery.mobileMin} {
        padding: calc(${spacing.sm} - ${borderWidth.sm}) calc(${spacing.xxl} - ${borderWidth.sm});
      }
      ${mediaQuery.tablet} {
        padding: calc(${spacing.md} - ${borderWidth.sm}) calc(${spacing.xxl} - ${borderWidth.sm});
      }
    `}

  ${({ $isOutlinedDark }) =>
    $isOutlinedDark &&
    `
      background: transparent;
      border: ${borderWidth.sm} solid ${colors.black};
      color: ${colors.black};
      border-radius: ${borderRadius.xs};
      padding: calc(${spacing.sm} - ${borderWidth.sm}) calc(${spacing.md} - ${borderWidth.sm});
      ${mediaQuery.mobileMin} {
        padding: calc(${spacing.sm} - ${borderWidth.sm}) calc(${spacing.xxl} - ${borderWidth.sm});
      }
      ${mediaQuery.tablet} {
        padding: calc(${spacing.md} - ${borderWidth.sm}) calc(${spacing.xxl} - ${borderWidth.sm});
      }
    `}

  ${({ $isDisabled }) =>
    $isDisabled &&
    `
      background-color: ${colors.slate[100]};
      cursor: not-allowed;
      border: none;
    `}

  .btn-icon {
    margin-left: ${spacing.xxxs};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .btn-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`
